import { render, staticRenderFns } from "./ContentDatenschutz.vue?vue&type=template&id=27325db5&scoped=true&"
import script from "./ContentDatenschutz.vue?vue&type=script&lang=js&"
export * from "./ContentDatenschutz.vue?vue&type=script&lang=js&"
import style0 from "./ContentDatenschutz.vue?vue&type=style&index=0&id=27325db5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27325db5",
  null
  
)

export default component.exports